/**
 * Compatibilidade de template WhatsApp com disparo de pesquisa (fora da janela 24h).
 */

export function extractBodyText(rawData) {
  if (rawData == null) return "";
  const str = String(rawData).trim();
  if (!str) return "";
  try {
    const parsed = JSON.parse(str);
    if (parsed && typeof parsed === "object") {
      if (typeof parsed.body === "string") return parsed.body;
      if (Array.isArray(parsed.components)) {
        const bodyComponent = parsed.components.find(
          (c) => c && String(c.type || "").toUpperCase() === "BODY"
        );
        if (typeof bodyComponent?.text === "string") return bodyComponent.text;
      }
      if (typeof parsed.data === "string") return parsed.data;
    }
  } catch {
    /* texto puro */
  }
  return str;
}

export function countBodyPlaceholders(bodyText) {
  const matches = String(bodyText || "").match(/\{\{(\d+)\}\}/g);
  if (!Array.isArray(matches) || !matches.length) return 0;
  return Math.max(
    ...matches
      .map((m) => parseInt(m.replace(/\D/g, ""), 10))
      .filter((n) => Number.isFinite(n)),
    1
  );
}

function normalizeCategory(category) {
  return String(category || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "_");
}

function normalizeStatus(status) {
  return String(status || "")
    .trim()
    .toLowerCase();
}

/**
 * @returns {{
 *   ok: boolean,
 *   code?: 'not_approved'|'authentication'|'missing_link_variable'|'marketing_warning',
 *   severity?: 'error'|'warning',
 *   bodyParamCount?: number,
 * }}
 */
export function assessSurveyWhatsappTemplate(template) {
  if (!template || template.id == null) {
    return { ok: true };
  }

  const status = normalizeStatus(template.status);
  const approved = ["approved", "active", "enabled"].includes(status);
  if (!approved) {
    return {
      ok: false,
      code: "not_approved",
      severity: "error",
      bodyParamCount: Number(template.bodyParamCount) || 0,
    };
  }

  const category = normalizeCategory(template.category || template.templateType);
  if (category.includes("AUTH")) {
    return {
      ok: false,
      code: "authentication",
      severity: "error",
      bodyParamCount: Number(template.bodyParamCount) || 0,
    };
  }

  let bodyParamCount = Number(template.bodyParamCount);
  if (!Number.isFinite(bodyParamCount)) {
    const body =
      template.bodyText ||
      template.preview ||
      extractBodyText(template.data) ||
      "";
    bodyParamCount = countBodyPlaceholders(body);
  }

  if (bodyParamCount <= 0) {
    return {
      ok: false,
      code: "missing_link_variable",
      severity: "error",
      bodyParamCount: 0,
    };
  }

  if (category.includes("MARKETING")) {
    return {
      ok: true,
      code: "marketing_warning",
      severity: "warning",
      bodyParamCount,
    };
  }

  return { ok: true, bodyParamCount };
}

export function surveyTemplateIssueCopy(t, assessment) {
  if (!assessment?.code) return null;
  const base = `channelForm.closingSurveys.templateIssues.${assessment.code}`;
  return {
    title: t(`${base}.title`),
    cause: t(`${base}.cause`),
    fix: t(`${base}.fix`),
    severity: assessment.severity || "error",
  };
}
